import { HIGH_RISK_BUSINESS_FORM, HIGH_RISK_INDUSTRY_VALUE } from "../consts/agreement";
import { COMPANY_TYPES } from "../consts/company";

//
// https://docs.google.com/spreadsheets/d/1sa763Xm_V5r1rem3gPSFU7_EGSxrTeYUjlgiXEJ_k_8/edit?usp=sharing
//

export function isLegalCompany(form_of_business: string) {
  return [
    COMPANY_TYPES.PT,
    COMPANY_TYPES.CV,
    COMPANY_TYPES.FOUNDATION,
    COMPANY_TYPES.BMT,
    COMPANY_TYPES.COOPERATIVE,
    COMPANY_TYPES.BPR,
    COMPANY_TYPES.BPRS,
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.FIRM,
    COMPANY_TYPES.PJP
  ].includes(form_of_business);
}
export function isUniversity(form_of_business: string) {
  return [COMPANY_TYPES.UNIVERSITY].includes(form_of_business);
}
export function isIndividual(form_of_business: string) {
  // UMKM
  return [COMPANY_TYPES.INDIVIDUAL].includes(form_of_business);
}
export function isMinistry(form_of_business: string) {
  return [COMPANY_TYPES.MINISTRY, COMPANY_TYPES.GOVERNMENT_AGENCY, COMPANY_TYPES.GOVERMENT_ENTITIES].includes(
    form_of_business
  );
}
export function isIndividualCompany(form_of_business: string) {
  return [COMPANY_TYPES.INDIVIDUAL_COMPANY].includes(form_of_business);
}
export function isHighRiskBusinessForm(form_of_business: string) {
  return HIGH_RISK_BUSINESS_FORM.includes(form_of_business);
}
export function isHighRiskIndustry(industry: number) {
  return HIGH_RISK_INDUSTRY_VALUE.includes(industry);
}

export function isUMKM(form_of_business: string, industry: number) {
  return isIndividual(form_of_business) && !isHighRiskIndustry(industry);
}
export function isLowMedRisk(form_of_business: string, industry: number) {
  return !isIndividual(form_of_business) && !isHighRiskIndustry(industry);
}
export function isHighRisk(form_of_business: string, industry: number) {
  return isHighRiskIndustry(industry) || isHighRiskBusinessForm(form_of_business);
}
